import type { User } from '../types/usersDemo';
import { mockUsers } from '../data/mock/usersDemo';

const shouldUseMocks = (): boolean => {
  try {
    return String(import.meta.env.VITE_USE_MOCKS).toLowerCase() === 'true';
  } catch {
    return true;
  }
};

export async function getUsers(): Promise<User[]> {
  if (shouldUseMocks()) {
    return Promise.resolve(mockUsers as User[]);
  }
  // Placeholder: switch to real API when available
  return Promise.resolve(mockUsers as User[]);
}


